import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EquipementsComponent } from './equipements.component';
import { RouterModule, Routes } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ComponentsModule } from '../../components/components.module';
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { EquipementAddComponent } from './equipement-add/equipement-add.component';
import { EquipementEditComponent } from './equipement-edit/equipement-edit.component';
import {EquipementEdition} from '../../guards/equipement-edition-guard';
import {NgxMatomoTrackerModule} from 'ngx-matomo-client';
import { EquipementNewComponent } from './equipement-new/equipement-new.component';

const secondaryRoutes: Routes = [
  {
    path: '',
    component: EquipementsComponent
  },
  {
    path: 'ajouter',
    component: EquipementAddComponent,
    canActivate: []
  },
  {
    path: 'nouvel',
    component: EquipementNewComponent,
    canActivate: []
  },
  {
    path: 'personnaliser/:id',
    component: EquipementEditComponent,
    canActivate: [EquipementEdition]
  }
];

@NgModule({
  declarations: [
    EquipementsComponent,
    EquipementAddComponent,
    EquipementEditComponent,
    EquipementNewComponent
    ],
    imports: [
        CommonModule,
        RouterModule.forChild(secondaryRoutes),
        NgbModule,
        ComponentsModule,
        FontAwesomeModule,
        FormsModule,
        ReactiveFormsModule,
        NgxMatomoTrackerModule,
    ]
})
export class EquipementsModule {
}
